import { render, staticRenderFns } from "./AboutOurProduct.vue?vue&type=template&id=138bb300"
import script from "./AboutOurProduct.vue?vue&type=script&lang=js"
export * from "./AboutOurProduct.vue?vue&type=script&lang=js"
import style0 from "./AboutOurProduct.vue?vue&type=style&index=0&id=138bb300&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports